module.exports = __webpack_public_path__ + "assets/img/btn-download-pc-fb43b132.png";